import { useQuery } from "@tanstack/react-query";
import { apiV2 } from "@/lib/apiV2/apiV2";

export const useRolesV2 = () => {
  const {
    data: rolesData,
    error: roleError,
    isLoading: loadingRoles,
  } = useQuery({
    queryKey: ["rolesV2"],
    queryFn: apiV2.roles.getAll,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const roles = rolesData?.data || [];

  return { roles, roleError, loadingRoles };
};
